<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 pb-lg-12 pb-5>
        <v-img
          :style="
            $vuetify.breakpoint.name == 'xs'
              ? 'height:50vh'
              : $vuetify.breakpoint.name == 'sm'
              ? 'height:30vh'
              : $vuetify.breakpoint.name == 'md'
              ? 'height:30vh'
              : (style = 'height:60vh')
          "
          src="../../assets/images/slider1.png"
          class="align-center"
        >
          <v-layout wrap>
            <v-flex xs12 text-center class="play">
              Direct from Hivekeepers
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>
      <v-flex xs12 class="head" text-center v-if="bee.sellerProfileId">{{
        bee.sellerProfileId.displayName
      }}</v-flex>
      <v-flex xs10 pb-lg-3>
        <v-layout wrap justify-center text-center v-if="bee.sellerProfileId">
          <v-flex text-right align-self-end class="clr">1.5 Miles Away </v-flex>
          <v-flex md2 lg2 align-self-end>
            <v-rating
              :value="parseFloat(bee.sellerProfileId.rating)"
              small
              color="#FDC944"
              background-color="#C7BCBC"
              readonly
            >
            </v-rating>
          </v-flex>
          <v-flex text-left align-self-center class="clr">
            {{ bee.sellerProfileId.rating }}</v-flex
          >
        </v-layout>
      </v-flex>
      <v-flex
        xs11
        pt-4
        md7
        text-center
        v-if="bee.sellerProfileId"
        style="font-family: robotoregular"
        class="clr"
      >
        {{ bee.sellerProfileId.heading }}
      </v-flex>
      <v-flex xs12 md11 py-16 v-if="splitUrl">
        <v-layout wrap px-sm-16 px-3>
          <v-flex xs12 md6 pl-md-5>
            <iframe
              height="380"
              :src="splitUrl"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              width="100%"
            ></iframe>
          </v-flex>
          <v-flex xs12 md6 pl-md-10>
            <v-layout wrap>
              <v-flex xs12 class="subhead" style="color: black">
                {{ bee.sellerProfileId.videoDescription }}
              </v-flex>
              <!-- <v-flex xs12 class="subhead" style="color: black" pb-3 pt-7>
                A good souurce of antioxidants
              </v-flex>
              <v-flex xs12 pb-2>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </v-flex>
              <v-flex xs12>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md11 py-16 v-if="bee.sellerProfileId">
        <v-layout wrap px-sm-16 px-3 v-if="bee.sellerProfileId.videoType=='file'">
          <v-flex xs12 md6 pl-md-5>
            <iframe
              height="380"
              :src="mediaURL + bee.sellerProfileId.video"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              width="100%"
            ></iframe>
          </v-flex>
          <v-flex xs12 md6 pl-md-10>
            <v-layout wrap>
              <v-flex xs12 class="subhead" style="color: black">
                {{ bee.sellerProfileId.videoDescription }}
              </v-flex>
              <!-- <v-flex xs12 class="subhead" style="color: black" pb-3 pt-7>
                A good souurce of antioxidants
              </v-flex>
              <v-flex xs12 pb-2>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </v-flex>
              <v-flex xs12>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 px-md-16>
        <v-layout wrap justify-end>
          <v-flex md6 text-right class="head">Our Products </v-flex>
          <v-flex pr-12 xs5 md5 text-right>
            <v-layout wrap justify-end v-if="product.length > 0">
              <v-flex xs1 text-right class="clr RB" pt-3> FILTER</v-flex>
              <v-flex xs3 pt-3 text-right>
                <span style="color: #000000; font-family: robotomedium"
                  >Most Popular</span
                >
              </v-flex>
              <v-flex xs1 text-right>
                <v-select solo flat dense></v-select
              ></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md11>
        <v-layout wrap px-md-12 pb-12 v-if="product.length > 0">
          <v-flex sm6 md4 v-for="(item, i) in product" :key="i">
            <v-card flat>
              <v-layout wrap justify-center text-center px-10 py-6>
                <v-flex
                  xs12
                  pb-2
                  style="cursor: pointer"
                  @click="goTo(item._id)"
                  v-if="item.photos[0]"
                >
                  <v-img max-height="500" :src="mediaURL + item.photos[0]">
                    <template v-slot:placeholder> <ImageLoader /> </template>
                  </v-img>
                </v-flex>
                <v-flex style="font-family: robotobold" xs12>
                  {{ item.productName }}
                </v-flex>
                <v-flex xs12 pt-1>
                  <span style="font-weight: bold"
                    >Rs. {{ item.offerPrice.toFixed(2) }}
                  </span>
                  <span v-if="item.price!=item.offerPrice" style="color: gray">
                    <del> Rs. {{ item.price }}</del></span
                  >
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-btn  @click="goTo(item._id)" color="#080B0A" tile width="100%">
                    <span style="color: white; font-family: robotoregular">
                      view details</span
                    >
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 text-center pt-5 v-if="product.length > 4">
            <v-btn to="/products" outlined width="30%" tile> VIEW ALL PRODUCTS</v-btn>
          </v-flex>
        </v-layout>
        <v-layout justify-center wrap v-else py-5>
          <v-flex xs12 text-center>
            <span style="font-family: robotomedium">No Data Found...</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-center class="head">Hive Gallery </v-flex>
      <v-flex px-2 xs12 pb-12 pt-5 v-if="bee.sellerProfileId">
        <OwlCarousel :nav="true" :dots="false" :responsive="owlResponsive">
          <template v-for="(item, i) in bee.sellerProfileId.hiveGallery">
            <v-layout wrap :key="i">
              <v-flex px-md-1 px-lg-3 pl-sm-2 px-xs-0>
                <v-card tile elevation="0">
                  <div v-viewer style="display: flex">
                  <img height="400px" cover :src="mediaURL + item"
                  />
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </OwlCarousel>
      </v-flex>
      <v-flex xs12 text-center v-if="!bee.sellerProfileId.hiveGallery">
        <span style="font-family: robotomedium">No Data Found...</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      trends: ["1", "3", "5", "7", "8", "9", "10", "11", "12", "12"],
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      items: ["f2", "f1", "f3", "f2", "f1", "f3", "f2", "f1", "f3"],
      bee: [],
      product: [],
      videos: [],
      splitUrl: "",
      appLoading: false,
      ServerError:false,
      rating: 4.5,
    };
  },
  mounted() {
    this.getData();
    this.getProduct();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/beekeeper/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.bee = response.data.data;
          this.videos = this.bee.sellerProfileId.videoUrl;
          if (this.bee.sellerProfileId.videoUrl) {
            this.cutVideo(this.bee.sellerProfileId.videoUrl);
          }
          // for (let j = 0; j < this.videos.length; j++) {
          //   this.cutVideo(this.videos[j]);
          // }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      // this.programs.video[0]
      // this.splitUrl(eve.replace("https://youtu.be/", embed));
      var em = eve.replace("https://www.youtube.com/watch?v=", b);
      em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
      // console.log(this.splitUrl);
    },
    getProduct() {
      this.appLoading = true;
      var user = {};
      user["uid"] = this.id;
      axios({
        method: "POST",
        url: "/product/getlist",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   id: this.id,
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    goTo(val) {
      this.$router.push({
        path: "/productdetail",
        query: {
          searchkey: val,
        },
      });
      console.log("val is=", val);
    },
  },
};
</script>